import { DEFAULT_ICON_SETTINGS_VALUE } from '@/components/ColorOrEmojiPicker/consts';
import {
  CreateMetricInput,
  CronFrequencyEnum,
  CustomFrequencyEnum,
  CustomFrequencyInput,
  DayOfWeekEnum,
  KeyResultMetricEnum,
  MetricSyncTypeEnum,
  MetricTypeEnum,
  WeekOfMonthEnum,
} from '@/types/schema';
import { getCurrentTimeZoneValue } from '@/utils/timezone';

export const REPEAT_SCHEDULE_CUSTOM_FREQUENCY: CustomFrequencyInput = {
  interval: 1,
  frequency: CustomFrequencyEnum.Day,
  weeksOfMonth: [WeekOfMonthEnum.First],
  daysOfWeek: [DayOfWeekEnum.Monday],
};

export const CREATE_HABIT_INITIAL_VALUES: CreateMetricInput = {
  name: '',
  type: MetricTypeEnum.Habit,
  syncConfig: { type: MetricSyncTypeEnum.Manual },
  iconSettings: DEFAULT_ICON_SETTINGS_VALUE,
  measurementUnit: KeyResultMetricEnum.Toggle,
  reminders: [],
  repeatSchedule: {
    frequency: CronFrequencyEnum.Custom,
    time: '00:00',
    timezone: getCurrentTimeZoneValue(),
    custom: REPEAT_SCHEDULE_CUSTOM_FREQUENCY,
    startDate: new Date().toISOString(),
  },
  defaultTargetValue: 0,
  defaultTargetValueUnit: '',
};
